// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_h5-3";
export var flatBottomCorners = "_h5-5";
export var productImage = "_h5-0";
export var quantityContainer = "_h5-2";
export var quantityHeader = "_h5-6";
export var tooltip = "_h5-1";
export var wrapAndEllipsesOverflow = "_h5-4";